import { ROUTES } from '../../../../constants/RouteNameMapping';
import { PanelMetadata, TearsheetPanelType } from './types';

// A4 paper dimensions: 210mm x 297mm
export const A4_WIDTH_MM = 210;
export const A4_HEIGHT_MM = 297;
export const A4_ASPECT_RATIO = A4_HEIGHT_MM / A4_WIDTH_MM; // ~1.414

export const TEARSHEET_PANELS: Record<TearsheetPanelType, PanelMetadata> = {
  header: {
    type: 'header',
    label: 'Header',
    description: 'Logo and company info display',
    configRoute: ROUTES.TEAR_SHEETS_HEADER_CONFIG,
  },
  companySummary: {
    type: 'companySummary',
    label: 'Company Summary',
    description: 'Foundational company data',
    configRoute: ROUTES.TEAR_SHEETS_COMPANY_SUMMARY_CONFIG,
  },
  investmentThesis: {
    type: 'investmentThesis',
    label: 'Investment Thesis',
    description: 'Qualitative investment rationale',
    configRoute: ROUTES.TEAR_SHEETS_INVESTMENT_THESIS_CONFIG,
  },
  performanceCommentary: {
    type: 'performanceCommentary',
    label: 'Performance Commentary',
    description: 'Text-based performance notes',
    configRoute: ROUTES.TEAR_SHEETS_PERFORMANCE_COMMENTARY_CONFIG,
  },
  companyDescription: {
    type: 'companyDescription',
    label: 'Company Description',
    description: 'Narrative company information',
    configRoute: ROUTES.TEAR_SHEETS_COMPANY_DESCRIPTION_CONFIG,
  },
  investmentSummary: {
    type: 'investmentSummary',
    label: 'Investment Summary',
    description: 'Financial investment metrics (MOIC, IRR, etc.)',
    configRoute: ROUTES.TEAR_SHEETS_INVESTMENT_SUMMARY_CONFIG,
  },
  financingHistory: {
    type: 'financingHistory',
    label: 'Financing History',
    description: 'Round-by-round funding data',
    configRoute: ROUTES.TEAR_SHEETS_FINANCING_HISTORY_CONFIG,
  },
  performanceSummary: {
    type: 'performanceSummary',
    label: 'Performance Summary',
    description: 'Tabular KPI performance data',
    configRoute: ROUTES.TEAR_SHEETS_PERFORMANCE_SUMMARY_CONFIG,
  },
  capitalizationSummary: {
    type: 'capitalizationSummary',
    label: 'Capitalization Summary',
    description: 'Cap table equity/debt breakdown',
    configRoute: ROUTES.TEAR_SHEETS_CAPITALIZATION_SUMMARY_CONFIG,
  },
};

export const PANEL_LIST: PanelMetadata[] = Object.values(TEARSHEET_PANELS);
